import React, { useCallback, useState, useContext, useEffect, useRef } from "react";
import styled from 'styled-components';
import { AuthContext } from "../../context/AuthContext";

const Iframe = styled.iframe`
  width: 100%;
`;

const USER_REGISTRY_URL = process?.env?.REACT_APP_USER_REGISTRY_URL || null;

const UserRegistry = () => {
    const iframe = useRef();

    const { getCurrentJWT } = useContext(AuthContext);

    const sendToken = useCallback(() => {
        console.log("UserRegistry [Shell]: Requesting JWT token...");
        getCurrentJWT().then(t => {
            console.log("UserRegistry [Shell]: Token retrieved, posting message to iframe. token length:", t ? t.length : 0);
            if (iframe.current?.contentWindow) {
                iframe.current.contentWindow.postMessage({
                    token: `Bearer ${t}`
                }, '*');
            } else {
                console.warn("UserRegistry [Shell]: iframe contentWindow not accessible");
            }
        });
    });

    const handleMessage = useCallback(event => {
        console.log("UserRegistry [Shell]: Received postMessage event origin:", event.origin, "data:", event.data);
        if (!USER_REGISTRY_URL) {
            console.warn("UserRegistry [Shell]: USER_REGISTRY_URL is not defined");
            return;
        }
        try {
            const registryUrl = new URL(USER_REGISTRY_URL);
            const originUrl = new URL(event.origin);

            console.log("UserRegistry [Shell]: Comparing origin:", originUrl.origin, "with registry URL origin:", registryUrl.origin);
            if (event.data === 'tokenRequest' && originUrl.origin === registryUrl.origin) {
                sendToken();
            } else {
                console.log("UserRegistry [Shell]: Ignore message - condition mismatch", {
                    isTokenRequest: event.data === 'tokenRequest',
                    originMatch: originUrl.origin === registryUrl.origin
                });
            }
        } catch (e) {
            console.error("UserRegistry [Shell]: Error processing postMessage event", e);
        }
    }, []);

    useEffect(() => {
        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        }
    }, []);

    if (USER_REGISTRY_URL === null) {
        return <span>No URL defined {process.env.USER_REGISTRY_URL}</span>
    }

    return <Iframe ref={iframe} src={USER_REGISTRY_URL} />
}

export default UserRegistry;